export default "__VITE_ASSET__CxxlkEHc__"